'use client'

import { useAuth } from '@/core/store/auth'
import { Link } from '@/i18n/navigation'

type FooterListProps = {
  title: string
  items: {
    label: string
    href: string
    target?: React.HTMLAttributeAnchorTarget
    protected?: boolean
  }[]
}

export const FooterList: React.FC<FooterListProps> = ({ title, items }) => {
  const { isAuthenticated } = useAuth()
  const links = items.filter(item => {
    if (item.protected && !isAuthenticated) return false

    return true
  })
  return (
    <div className='space-y-6'>
      <h2 className='text-red text-xl font-medium'>{title}</h2>
      <ul className='space-y-4'>
        {links.map(item => (
          <li key={item.label}>
            <Link
              href={item.href}
              target={item.target}
              className='hover:underline'
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
